import { api } from '@shared-runtime/api';

// @line
import { normalize } from './normalize';
import type {
  FeatureControlRequest,
  FeatureControlResponseData,
} from './types';

export * from './types';

export async function fetchFeatureControl(
  params: FeatureControlRequest,
): Promise<FeatureControlResponseData> {
  return api.bff
    .get<FeatureControlResponseData>('/v3/feature-control', { params })
    .normalize(normalize);
}
